module.exports = __webpack_public_path__ + "static/media/img-ceo@2x.ce9f0677.png";